import { render } from "./CustomToast.vue?vue&type=template&id=70f73f9b&scoped=true"
import script from "./CustomToast.vue?vue&type=script&lang=js"
export * from "./CustomToast.vue?vue&type=script&lang=js"

import "./CustomToast.vue?vue&type=style&index=0&id=70f73f9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f73f9b"]])

export default __exports__